<template>
  <div class="sala-page container-fluid mt-4">
    <div class="funcionalidad-container shadow-sm p-3 bg-white rounded">
      <!-- Título y botón para crear -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="mb-0">
          <font-awesome-icon icon="fas fa-home" class="me-2" />
          Espacios de Cultivo
        </h2>
        <button @click="mostrarComponente('AltaSala')" class="btn btn-sm btn-outline-success">
          <font-awesome-icon icon="fas fa-plus" class="me-1" /> Crear Espacio
        </button>
      </div>

      <!-- Filtros -->
      <div class="filters mb-3">
        <div class="row g-2">
          <div class="col-md-6">
            <input type="text" class="form-control" v-model="filterNombre" placeholder="Buscar por nombre" />
          </div>
          <div class="col-md-6">
            <select v-model="filterTipo" class="form-select">
              <option value="">Todos los tipos</option>
              <option v-for="tipo in tiposSala" :key="tipo" :value="tipo">{{ tipo }}</option>
            </select>
          </div>
          <div class="col-12">
            <button class="btn btn-secondary w-100" @click="clearFilters">Limpiar Filtros</button>
          </div>
        </div>
      </div>

      <!-- Lista de tarjetas -->
      <div class="cards-list">
        <div v-for="sala in paginatedSalas" :key="sala.id" class="card sala-card mb-3">
          <div class="row g-0">
            <!-- Icono grande a la izquierda -->
            <div class="col-md-2 d-flex align-items-center justify-content-center sala-icon-container">
              <div class="sala-icon">
                <font-awesome-icon icon="fas fa-building" size="3x" />
              </div>
            </div>
            <!-- Información de la sala -->
            <div class="col-md-10">
              <div class="card-body">
                <h5 class="card-title">{{ sala.nombre }}</h5>
                <p class="card-text" v-if="sala.descripcion">{{ sala.descripcion }}</p>
                <p class="card-text"><strong>Tipo:</strong> {{ sala.tipo }}</p>
                <p class="card-text" v-if="sala.capacidad"><strong>Capacidad:</strong> {{ sala.capacidad }}</p>
                <p class="card-text" v-if="sala.ubicacion"><strong>Ubicación:</strong> {{ sala.ubicacion }}</p>
              </div>
              <div class="card-footer d-flex justify-content-end">
                <button @click="mostrarEditarSala(sala)" class="btn btn-sm btn-outline-primary me-2">
                  <font-awesome-icon icon="fas fa-edit" class="me-1" /> Editar
                </button>
                <button @click="mostrarComponente('EliminarSala', sala)" class="btn btn-sm btn-outline-danger">
                  <font-awesome-icon icon="fas fa-trash-alt" class="me-1" /> Eliminar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Paginación -->
      <nav v-if="totalPages > 1" class="mt-3">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a class="page-link" href="#" @click.prevent="prevPage">Anterior</a>
          </li>
          <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
            <a class="page-link" href="#" @click.prevent="currentPage = page">{{ page }}</a>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <a class="page-link" href="#" @click.prevent="nextPage">Siguiente</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Componente dinámico para acciones (crear, editar, eliminar) -->
    <component
      v-if="componenteActivo"
      :is="componenteActivo"
      :sala="salaEnAccion"
      :club_id="club_id"
      @accionTerminada="accionCompletada"
      class="mt-3"
    />
  </div>
</template>

<script>
import { markRaw } from 'vue';
import axios from '@/axios';
import AltaSala from './alta-salaDeCultivo.vue';
//import EditarSala from './editar-salaDeCultivo.vue';
import EliminarSala from './eliminar-salaDeCultivo.vue';

export default {
  props: {
    club_id: {
      type: Number,
      required: true,
    },
  },
  components: {
    AltaSala,
    //EditarSala,
    EliminarSala,
  },
  data() {
    return {
      salas: [],
      filterNombre: '',
      filterTipo: '',
      // Arreglo de tipos de sala
      tiposSala: ["sala", "vivero", "campo", "invernadero", "otro"],
      // Paginación
      currentPage: 1,
      pageSize: 5,
      // Componente dinámico
      componenteActivo: null,
      salaEnAccion: null,
    };
  },
  computed: {
    filteredSalas() {
      return this.salas.filter(sala => {
        const matchNombre = this.filterNombre
          ? sala.nombre.toLowerCase().includes(this.filterNombre.toLowerCase())
          : true;
        const matchTipo = this.filterTipo ? sala.tipo === this.filterTipo : true;
        return matchNombre && matchTipo;
      });
    },
    paginatedSalas() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredSalas.slice(start, start + this.pageSize);
    },
    totalPages() {
      return Math.ceil(this.filteredSalas.length / this.pageSize);
    },
  },
  async created() {
    await this.obtenerSalas();
  },
  methods: {
    async obtenerSalas() {
      try {
        const response = await axios.get(`/api/salasDeCultivoJoinClubByclub_id/`,{
          params: {
            club_id: this.club_id,
          },
        });
        this.salas = response.data;
      } catch (error) {
        console.error('Error al obtener salas:', error);
      }
    },
    mostrarComponente(componente, sala = null) {
      this.componenteActivo = markRaw(this.$options.components[componente]);
      this.salaEnAccion = sala;
    },
    mostrarEditarSala(sala) {
      this.$emit('EditarSala', sala);
    },
    async accionCompletada() {
      this.componenteActivo = null;
      this.salaEnAccion = null;
      await this.obtenerSalas();
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    clearFilters() {
      this.filterNombre = '';
      this.filterTipo = '';
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>
.sala-page {
  padding: 20px;
  background-color: #f7f8fa;
}

.funcionalidad-container {
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 15px;
}

h2 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
}

.filters input,
.filters select {
  width: 100%;
}

.cards-list {
  display: flex;
  flex-direction: column;
}

.sala-card {
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s ease;
}

.sala-card:hover {
  transform: translateY(-5px);
}

.sala-icon-container {
  background-color: #e9ecef;
  padding: 15px;
}

.sala-icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dee2e6;
  border-radius: 50%;
}

.card-body {
  padding: 15px;
}

.card-footer {
  background-color: #f8f9fa;
  padding: 10px 15px;
}

.pagination {
  margin-top: 20px;
}
</style>
